module.exports = __webpack_public_path__ + "img/endless_possibilities@2x.ae4099e.jpg";